import { render } from "./JSONConfig.vue?vue&type=template&id=6b42a2c1&scoped=true"
import script from "./JSONConfig.vue?vue&type=script&lang=js"
export * from "./JSONConfig.vue?vue&type=script&lang=js"

import "./JSONConfig.vue?vue&type=style&index=0&id=6b42a2c1&scoped=true&lang=css"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b42a2c1"]])

export default __exports__